export const PARAMS_CONFIG = [
    {
        parameter: "vazao",
        key: "vazao",
        label: "Vazão",
        extraFieldName: "escala",
        extraFieldLabel: "Escala",
        extraOptions: [
            { value: "maxima", label: "Máxima" },
            { value: "media", label: "Média" }
        ]
    },
    {
        parameter: "nivel",
        key: "nivel",
        label: "Nível",
        extraFieldName: "regime",
        extraFieldLabel: "Regime",
        extraOptions: [
            { value: "estatico", label: "Estático" },
            { value: "dinamico", label: "Dinâmico" }
        ]
    },
    {
        parameter: "horimetro",
        key: "horimetro_dia",
        label: "Horas por dia",
        extraFieldName: "agrupamento",
        extraFieldDefaultValue: "dia",
        recommendedSpecialOperator: "volume_dia",
        wrongParamOperatorMessage: "O parâmetro selecionado não é compatível com o operador especial de Volume do Dia. Pode haver inconsistências nos cálculos.",
    },
    {
        parameter: "horimetro",
        key: "horimetro_mes",
        label: "Horas por mês",
        extraFieldName: "agrupamento",
        extraFieldDefaultValue: "mes",
        recommendedSpecialOperator: "volume_mes",
        wrongParamOperatorMessage: "O parâmetro selecionado não é compatível com o operador especial de Volume do Mês. Pode haver inconsistências nos cálculos.",
    },
    {
        parameter: "volume",
        key: "volume_dia",
        label: "Volume por dia",
        extraFieldName: "agrupamento",
        extraFieldDefaultValue: "dia",
        recommendedSpecialOperator: "volume_dia",
        wrongParamOperatorMessage: "O parâmetro selecionado não é compatível com o operador especial de Volume do Dia. Pode haver inconsistências nos cálculos.",
    },
    {
        parameter: "volume",
        key: "volume_mes",
        label: "Volume por mês",
        extraFieldName: "agrupamento",
        extraFieldDefaultValue: "mes",
        recommendedSpecialOperator: "volume_mes",
        wrongParamOperatorMessage: "O parâmetro selecionado não é compatível com o operador especial de Volume do Mês. Pode haver inconsistências nos cálculos.",
    },
];
